import { useTheme } from '@mui/material';
import React from 'react';
import { Conversation, TimeFormats } from 'src/graphql';
import { ChatInfo } from 'src/pages/Conversations/Chat/ChatInfo/chat-info';
import { getSnoozeConversationMessage } from 'src/pages/Conversations/Chat/ChatInfo/snoozed-conversation-message';
import { useDisplayTime } from 'src/utils/hooks';

interface SnoozeBannerProps {
  conversation: Conversation;
}

export const SnoozeBanner: React.FC<SnoozeBannerProps> = ({ conversation }) => {
  const theme = useTheme();
  const { timeFormatPref } = useDisplayTime();

  const hourCycle = timeFormatPref === TimeFormats.TwelveHour ? 'h12' : 'h24';

  const message = getSnoozeConversationMessage(
    conversation,
    theme.palette.custom.OV.sys.secondary,
    hourCycle,
  );

  if (!message) return null;

  return (
    <ChatInfo
      message={message}
      backgroundColor={theme.palette.custom.OV.sys.secondaryContainer}
      textColor={theme.palette.custom.OV.sys.secondary}
    />
  );
};
